import React from 'react';
import EmployerPageShell from './EmployerPageShell';

type EmployerCommerceShellProps = {
  title: string;
  description: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  activeSection?: 'billing' | 'build-request';
  compactHero?: boolean;
};

const EmployerCommerceShell: React.FC<EmployerCommerceShellProps> = ({
  title,
  description,
  actions,
  children,
  activeSection,
  compactHero = false,
}) => {
  return (
    <EmployerPageShell activeSection={activeSection}>
      <section
        className={`flex flex-col gap-4 rounded-[18px] border border-[#dbe4e1] bg-[linear-gradient(135deg,#ffffff_0%,#f0fdfa_100%)] px-5 shadow-[0_18px_40px_rgba(15,23,42,0.06)] sm:flex-row sm:items-end sm:justify-between sm:px-7 ${
          compactHero ? 'py-4 sm:py-5' : 'py-5 sm:py-6'
        }`}
      >
        <div className="max-w-[720px]">
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#0d9488]">Employer Commerce</p>
          <h1 className="mt-2 font-display text-[28px] font-bold leading-tight text-[#0f172a] sm:text-[34px]">
            {title}
          </h1>
          <p className="mt-2 max-w-[640px] text-[14px] leading-6 text-[#475569]">{description}</p>
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-3">{actions}</div> : null}
      </section>

      {children}
    </EmployerPageShell>
  );
};

export default EmployerCommerceShell;
